import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';

import { getConfig } from '@edx/frontend-platform';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

let themeCookie = 'indigo-toggle-dark';
let themeCookieExpiry = 90; // days

const AddDarkTheme = () => {
  const cookies = new Cookies();
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const getCookieExpiry = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() + themeCookieExpiry);
  };

  const getCookieOptions = () => {
    const serverURL = new URL(getConfig().LMS_BASE_URL);
    const options = { domain: serverURL.hostname, path: '/', expires: getCookieExpiry() };
    return options;
  };

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body{
            background-color: #0D0D0E;
            color: #ccc;
          }
          a {color: #ccc;}
          a:hover{color: #d3d3d3;}
          `;
        if (iframes[index].contentDocument) { iframes[index].contentDocument.head.appendChild(style); }
      });
    }
  };

  useEffect(() => {
    const theme = cookies.get(themeCookie);

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    if (isThemeToggleEnabled && theme === 'dark') {
      document.body.classList.add('indigo-dark-theme');
      
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage

      cookies.set(themeCookie, theme, getCookieOptions());      //  on page load, update expiry
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
      addPlugins(config, 'studio_footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'account') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'communications') {
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'discussions') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'gradebook') {
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'learner-dashboard') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'learning') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'ora-grading') {
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'profile') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                  op: PLUGIN_OPERATIONS.Insert,
                  widget: {
                    id: 'custom_footer',
                    type: DIRECT_PLUGIN,
                    RenderWidget: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
                      <span style={{
                                  textAlign: 'left',
                                  fontSize: 14,
                                  color: 'black',
                                  marginLeft: 4,
                                  marginBottom: 4,
                                }}
                        >
                        © Made Purple, All rights Reserved</span>
                        </div>
                    ),
                  },
                },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;